<template>
  <section class="headers">
    <!-- start navbar links header -->
    <div class="the-header">
      <div class="m-container">
        <div class="row" style="align-items: center">
          <!-- start logo wro -->
          <div class="col-1 the-logo">
            <router-link to="/">
              <img src="@/assets/img/logo/logo_h_2.png">
            </router-link>
          </div>
          <!-- end logo wro -->
          <!-- start navbar links with register button -->
          <div class="col the-links">
            <div class="row">
              <div class="col links">
                <!-- links -->
                <ul>
                  <li>
                    <router-link to="/">home</router-link>
                  </li>                  
                  <li>
                    <router-link to="/about-us">About</router-link>
                  </li>
                  <li>
                    <router-link to="/competitions">Competitions</router-link>
                  </li>
                  <li>
                    <router-link to="/event">events</router-link>
                  </li>
                  <li>
                    <router-link to="/training-support">Training & Support</router-link>
                  </li>
                  <li>
                    <router-link to="/faq">FAQ</router-link>
                  </li>
                  <li>
                    <router-link to="/01-space">01Space</router-link>
                  </li>
                </ul>
                <!-- end links -->
              </div>
              <div class="col-2 toggle-controll">
                <!-- register button -->
                <div class="button-register" v-if="!userState">
                  <div class="the-button">
                    <router-link tag="button" to="/sign-In" class="wro-button"><span>Register/Login</span></router-link>                    
                  </div>
                </div>
                <!-- end register button -->

                <!-- user info ! if user is logged in -->
                <div class="col user-info" v-else>
                  <div class="user-img">
                    <router-link :to="{path: '/profile', query: {page: 'Teams'}}">
                      <img :src="userData.image" v-if="userData.image !== null">
                      <img src="@/assets/img/user/avatar_profile.png" v-else>
                    </router-link>
                  </div>
                  <div class="user-name">
                    <router-link :to="{path: '/profile', query: {page: 'Teams'}}">
                      {{ userData.name }}
                    </router-link>
                  </div>
                  <div class="user-option notification">
                   <q-btn-dropdown @click="get_notification" icon="fas fa-bell">
                      <q-list class="notifications-list">
                        <q-item>
                          Notifications
                        </q-item>


                        <template>
                          <SpinnerLoading class="test" v-if="loading"></SpinnerLoading>

                          <template v-else>

                            <router-link :to="{ name: 'Profile', query: { page: 'Notification'} }">
                              <q-item v-for="item in all_notifications" :key="item.id" class="single-notification" clickable v-close-popup>
                                <q-item-section>
                                  <img src="@/assets/img/user/avatar_profile.png" alt="">
                                  <div>
                                    <p class="notification-title"> {{item.message}} </p>
                                    <p class="notification-time"> {{ item.created_at }} </p>
                                  </div>
                                </q-item-section>
                              </q-item>
                            </router-link>

                            <p class="watermark" v-if="all_notifications.length === 0">Notifications</p>
                          </template>
                        </template>


                        <q-item clickable v-close-popup>
                          <q-item-section>
                            <q-item-label>See all notifications</q-item-label>
                            <svg xmlns="http://www.w3.org/2000/svg" width="6.289" height="11" viewBox="0 0 6.289 11">
                              <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back"
                                    d="M15.644,11.692,11.481,7.533a.786.786,0,0,1,1.113-1.11l4.716,4.712a.785.785,0,0,1,.023,1.084L12.6,16.965a.786.786,0,0,1-1.113-1.11Z"
                                    transform="translate(-11.251 -6.194)"/>
                            </svg>
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-btn-dropdown>
                    <div class="arrow-down"><i class="fas fa-chevron-down"></i></div>
                  </div>
                </div>
                <!-- end user info ! if user is logged in -->
              </div>
            </div>
          </div>
          <!-- end navbar links -->
        </div>
      </div>
    </div>
    <!-- end navbar links header -->
  </section>
</template>


<script>
import SpinnerLoading from "@/components/Loading/SpinnerLoading";

export default {
  data:() => ({
    loading: true,
    all_notifications: [],
  }),

  components: {SpinnerLoading},


  computed: {
    userState() {
      return this.$store.state.userState;
    },
    userData() {
      return this.$store.state.userData;
    }
  },

  methods : {

    get_notification() {
      this.$API.notification.get_notification()
          .then(response => {
            this.all_notifications = response.data.data;
            this.loading = false;
          }).catch(() =>{});
    }

  },

  mounted() {


  }

}
</script>

<style scoped>

.loading-holder {
  height: 17vh !important;
}
.watermark {
  height: auto;
  font-size: 36px;
}

.the-header {
  position: sticky;
  top: 0px;
  background: var(--mainColors);
  z-index: 55;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.the-header .the-logo {
  margin: 1.25em 0;
}

.the-header .the-logo img {
  width: 88px;
  display: block;
}

.the-header .the-links {
  text-align: right;
}

.the-header .the-links .links {
  display: flex;
  justify-content: center;
  align-items: center;
}

.the-header .the-links .button-register {
  text-align: right;
  margin-right: 17px;
}

.the-header .the-links .contact-us-head {
  font-size: 12px;
  margin: 0px 15px 0px 40px;
  color: var(--secondaryColors);
  text-transform: capitalize;
  padding: 0px;
}

.the-header .the-links .contact-us-head li {
  margin: 0px;
}

.the-header .the-links .contact-us-head li span {
  font-weight: bold !important;
  color: #1D1D1D;
  margin: 0px 13px;
  cursor: pointer;
}

.the-header .the-links .contact-us-head li span svg {
  width: 10px;
  position: relative;
  left: 3px;
}

.the-header ul {
  display: inline-block;
  padding-right: 10px;
  padding-left: 0px;
}

.the-header ul li {
  display: inline-block;
  margin: 0px 20px;
}

.the-header ul a {
  text-transform: capitalize;
  color: white;
  font-weight: 400;
  transition: 0.3s ease all;
}

.the-header ul a.router-link-exact-active {
  font-weight: 500;
  position: relative;
  transition: 0.2s ease-out all;
}


.the-header ul a.router-link-exact-active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translate(-50%);
  width: 41px;
  height: 2px;
  background: #ffffff;
}


.the-header .toggle-controll .user-info {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  font-family: 'Tajawal', sans-serif;

}

.the-header .toggle-controll .user-info .user-img {
  width: 47px;
  height: 47px;
  cursor: pointer;
}

.the-header .toggle-controll .user-info .user-img img {
  width: 100%;
  object-fit: cover;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
  width: 47px;
  height: 47px
}

.the-header .toggle-controll .user-info .user-name {
  margin: 0px 13px;
  cursor: pointer;
}

.the-header .toggle-controll .user-info .user-name a {
  font-size: 0.813rem;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
}

.user-option {
  display: flex;
}

.the-header .toggle-controll .user-info .user-option div i {
  width: 26px;
  height: 26px;
  text-align: center;
  cursor: pointer;
}

.the-header .toggle-controll .user-info .user-option div.arrow-down i {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: var(--mainColors);
  background: #ffffff !important;
  line-height: 2.5;
  font-size: 11px;
}

.the-header .user-info .user-option .fa-bell {
  font-size: 21px !important;
  color: #ffffff;
}

.the-header .user-info .q-btn__wrapper .q-btn-dropdown__arrow {
  display: none !important;
}

.the-header .q-btn__wrapper:before {
  box-shadow: none;
}

.the-header .toggle-controll .user-info .user-option div:nth-child(2) {
  padding-left: 9px;
  border-left: 2px solid #ffffff;
  display: flex;
  align-items: center;
}

.the-header .toggle-controll .user-info .user-option div:nth-child(1) {
  padding-right: 9px;
}


@media (max-width: 1125px) {

  .the-header ul li {
    margin: 0px 15px;
  }

  .links {
    padding: 0px !important;
  }

  .links ul {
    padding: 0px;
  }

}

@media (max-width: 970px) {

  .the-header ul li {
    margin: 0px 12px;
  }
 .the-header .the-links .button-register { margin-right: 0px; margin-top: 6px;}
}

@media (max-width: 901px) {

  .the-header ul li {
    margin: 0px 10px;
  }  
}

@media (max-width: 841px) {

  .the-header ul li {
    margin: 0px 8px;
  }

  .links {
    padding-right: 15px;
    justify-content: flex-end !important;
  } 
  
}
</style>